import React from 'react';
import { cn } from '../../../utils/cn';
import {
  SELECTION_FLOW,
  SELECTION_FLOW_HEADING,
  SELECTION_FLOW_SPECIAL,
  SELECTION_FLOW_SPECIAL_HEADING,
  SELECTION_FLOW_SPECIAL_NOTE,
} from '../content';
import { isRaid2026SpecialSelectionStarted } from '../../../config/raid2026';
import styles from './SelectionFlow.module.css';

const ASSET_BASE = `${process.env.PUBLIC_URL}/assets/images/raid2026`;

// LP リデザイン版（lp_sample）準拠。STEP ラベルは持たず、台形カードで流れを表す。
// wide: 横長すぎる SVG は縮小、large: 余白の多い SVG は拡大して見た目を揃える。
// 特別選考フェーズではステップ数が変わるため、content 側の icon キーで引く。
const ICONS = {
  entry: { file: 'selection_step_01_entry.svg', large: true },
  document: { file: 'selection_step_02_document.svg' },
  inPerson: { file: 'selection_step_03_in_person.svg' },
  onlineInterview: {
    file: 'selection_step_04_online_interview.svg',
    wide: true,
  },
  internship: { file: 'selection_step_05_internship.svg' },
};

export default function SelectionFlow() {
  const isSpecialSelection = isRaid2026SpecialSelectionStarted();
  const steps = isSpecialSelection ? SELECTION_FLOW_SPECIAL : SELECTION_FLOW;

  return (
    <section id="selection" className={styles.band}>
      <div className={styles.inner}>
        <span className={styles.tag}>
          {isSpecialSelection
            ? SELECTION_FLOW_SPECIAL_HEADING
            : SELECTION_FLOW_HEADING}
        </span>
        <ol
          className={styles.steps}
          style={{ '--selection-step-count': steps.length }}
        >
          {steps.map((item, i) => {
            const icon = ICONS[item.icon];

            return (
              <li key={item.step} className={styles.step}>
                <div
                  className={styles.card}
                  style={{ '--selection-step-index': i }}
                >
                  <div className={styles.cardInner}>
                    <div className={styles.cardHead}>
                      <p className={styles.cardTitle}>
                        {item.body.split('（')[0]}
                      </p>
                    </div>
                    <span className={styles.cardDivider} aria-hidden="true" />
                    <div className={styles.cardIcon}>
                      <img
                        src={`${ASSET_BASE}/${icon.file}`}
                        alt=""
                        aria-hidden="true"
                        className={cn(
                          styles.icon,
                          icon.wide && styles.iconWide,
                          icon.large && styles.iconLarge
                        )}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
        {isSpecialSelection && (
          <p className={styles.note}>{SELECTION_FLOW_SPECIAL_NOTE}</p>
        )}
      </div>
    </section>
  );
}
